import type { SubmissionPublisher } from '@planuze/admin-contracts';
import { StatusBadge } from '@planuze/ui';
import { Link } from '@tanstack/react-router';
import { usePublishersContent } from '../../content/sections/publishers.js';
import { statusLabel, statusTone } from '../publishers/publisher-status-map.js';

interface Props {
  readonly publisher: SubmissionPublisher | null | undefined;
  /** Fallback honesto quando o publisher não resolve (client falha/404 — ADR-0462 §6). */
  readonly publisherId: string;
}

/* Link para o detalhe do publisher (`/publishers/:id`, ADR-0476). Publisher não resolvido →
   mostra o `publisherId` cru, sem derrubar a página. */
export function PublisherLink({ publisher, publisherId }: Props) {
  const copy = usePublishersContent();
  if (publisher === null || publisher === undefined) {
    return <span className="font-mono text-xs text-muted-foreground">{publisherId}</span>;
  }
  return (
    <span className="inline-flex items-center gap-2">
      <Link
        to="/publishers/$id"
        params={{ id: publisherId }}
        className="font-medium text-foreground hover:text-primary"
      >
        {publisher.displayName}
      </Link>
      <StatusBadge variant={statusTone(publisher.status)} dot>
        {statusLabel(publisher.status, copy.statusLabels)}
      </StatusBadge>
    </span>
  );
}
